
function getAtribute( entidade, att ){

  if(entidade){
    return (entidade[att] || "").toLocaleUpperCase();
  }
  return "";
};

export default getAtribute;
